/* src/app/components/lead-details/to-do-list/to-do-list/to-do-list.component.css */
h1 {
  text-align: center;
  margin: 20px 0;
  color: #333;
}
.todo-list {
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.todo-item {
  background-color: #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  font-size: 1.143rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: background-color 0.3s ease;
}
.todo-item:hover {
  background-color: #c8e1e0;
}
.todo-item-title {
  color: #01796F;
}
.todo-status {
  color: #666;
  font-size: 1rem;
  background-color: white;
  padding: 8px 16px;
  border-radius: 100px;
  white-space: nowrap;
}
.todo-item-stacked {
  flex-direction: column;
  align-items: stretch;
}
.todo-item-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.todo-pending-list {
  list-style-type: none;
  margin: 10px 0 0 0;
  padding: 0;
}
.todo-pending-category {
  color: #01796F;
  font-size: 1rem;
  font-weight: bold;
}
.todo-pending-questions {
  margin: 2px 0 8px 0;
  padding-left: 24px;
  font-size: 1rem;
  color: #333;
}
.todo-pending-questions li {
  padding: 1px 0;
}
.todo-pending-list > li:last-child .todo-pending-questions {
  margin-bottom: 0;
}
.todo-item-main + .todo-pending-questions {
  margin: 10px 0 0 0;
}
/*# sourceMappingURL=to-do-list.component-G2BXVOYU.css.map */
